<template>
	<card-widget v-if="widgetType === 'card'" :articles="articles" :config="config" ref="cardWidget"></card-widget>
	<text-widget v-else-if="widgetType === 'text'" :articles="articles" :config="config"></text-widget>
</template>

<script>
import axios from 'axios';
import CardWidget from './components/CardWidget.vue';
import TextWidget from './components/TextWidget.vue';

export default {
	components: {
		CardWidget, TextWidget
	},
	props: {
		requestConfig: Object,
		articleWidgetConfig: Object
	},
	data() {
		return {
			SVC_CODES: ['topRank', 'daumapp', 'kakaotalkTab'],
			SVC_CAFE_TOP: 0,
			SVC_DAUMAPP: 1,
			SVC_KAKAOTALK: 2,
			articles: []
		};
	},
	computed: {
		svc() {
			return this.articleWidgetConfig.svcParam;
		},
		isNormalArticle() {
			return this.svc === '' || this.svc === this.SVC_CODES[this.SVC_CAFE_TOP];
		},
		isPopularArticle() {
			return this.svc === this.SVC_CODES[this.SVC_DAUMAPP] || this.svc === this.SVC_CODES[this.SVC_KAKAOTALK];
		},
		widgetType() {
			if (this.isPopularArticle) {
				return 'card';
			}
			return 'text';
		},
		config() {
			return {
				...this.articleWidgetConfig,
				isValidCode: this.SVC_CODES.indexOf(this.svc) !== -1,
				isPopularArticle: this.isPopularArticle
			}
		}
	},
	async created() {
		const {data} = await axios.get(this.requestConfig.url, {
			params: this.requestConfig.data,
			timeout: 5000,
			cache: false
		});
		this.articles = data;

		if (this.articleWidgetConfig.isDaumSearch && (!data || data.length === 0)) {
			document.getElementById('linkAlarmDiv').style.display = 'block';
		}

		await this.$nextTick();

		this.$refs.cardWidget.fetchAdfitNativeAds();
	}
}
</script>
